// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Y6PV","consentsList":"PatientConsents_consentsList__2Xp9k","consentsListEmpty":"PatientConsents_consentsListEmpty__1Phfb"};